'use strict';

/**
 * View for empty contact lists
 *
 * @category   View
 * @module     community
 * @copyright  Copyright (c) 2025, COLIDO (http://www.colido.net)
 * @author     Augusto Campos-Leiva <augusto@campos-leiva.de>
 */

var ItemView = require('base/Colido.ItemView');

var template = require('modules/community/templates/partials/conversation-posts-error.hbs');

var ErrorView = ItemView.extend({
    template: template,

    tagName: 'ol',

    className: 'conversation-posts error-hint',
});

module.exports = ErrorView;